// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1de1297b","513":"42770e05","999":"bdd6e4d5"}[chunkId] + ".chunk.js";
};